<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit product</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New parameters for {{ trademark }} 
                {{ model }} model
                of the {{ team }} team
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="material level quality" v-model.number="material"
                                    name="material" type="text" :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="manufacturing level quality"
                                    v-model.number="manufacturing" name="manufacturing" type="text"
                                    :rules="[rules.required, rules.number, rules.max]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="design level quality" v-model.number="design"
                                    name="design" type="text" :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="type of design" v-model="design_type" :items="types"
                                    :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="variations of model" v-model.number="variations"
                                    name="variations" type="text" :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" return-object label="advanced feature" clearable
                                    v-model="advanced_feature" 
                                    :items="features" 
                                    item-text="text" 
                                    item-value="value"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="sales plan" v-model.number="sales_plan"
                                    name="sales_plan" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="production plan" v-model.number="production_plan"
                                    name="production_plan" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="ex-works price" v-model.number="price"
                                    name="price" type="text" :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="retail price" v-model.number="retail_price"
                                    name="retail_price" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
                <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" :disabled="!haveBeenChanged || Boolean(error)"
                    @click="calculating">
                    Calculate
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!calculate || Boolean(error)"
                    @click="editProduct">
                    Save
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { UnitCost } from '../../../functions/product';

export default {
    name: 'EditProduct',
    props: ['product'],
    data() {
        return {
            dialog: false,
            valid: false,
            haveBeenChanged: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
                max: v => v <= 5 || 'max 5 expected',
            },
            types: ['classic', 'business', 'casual', 'innovative', 'art'],
            features: [
                'positioning tracker',
                'power bank',
                'missed items warning',
                'danger alarm',
                'fridge camera',
                'individual pictures',
                'against loss insurance',
                'environment friendly utilization',
                'charity profit sharing'
            ],
            calculate: false,
            trademark: this.product.trademark.name,
            model: this.product.model,
            team: this.product.team.name, 
            
            available_from: this.product.available_from, //month
            available_till: this.product.available_till,
            material: this.product.material,
            manufacturing: this.product.manufacturing,
            design_type: this.product.design_type, //enum
            design: this.product.design,
            variations: this.product.variations,
            advanced_feature: this.product.advanced_feature,
            sales_plan: this.product.sales_plan,
            production_plan: this.product.production_plan,
            retail_price: this.product.retail_price,
            price: this.product.price,
            unit_cost: this.product.unit_cost,

        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        onceMore() {
            this.error = '';
            this.calculate = false;
            this.message = '';
            this.haveBeenChanged = true;
        },
        getAFValue(param) {
            const features = [
                { text: 'positioning tracker', value: 1 },
                { text: 'power bank', value: 2 },
                { text: 'missed items warning', value: 3 },
                { text: 'danger alarm', value: 4 },
                { text: 'fridge camera', value: 5 },
                { text: 'individual pictures', value: 6 },
                { text: 'against loss insurance', value: 7 },
                { text: 'environment friendly utilization', value: 8 },
                { text: 'charity profit sharing', value: 9 }
            ]
            const inFeatures = features.find(item => item.text === param)
            if (inFeatures) {
                return inFeatures.value
            }
            return 0
        },
        calculating() {
            if (this.$refs.form.validate()) {

                if (!this.advanced_feature) {
                    this.unit_cost = UnitCost(this.material, this.manufacturing, this.variations)
                    //this.investments = Investments(this.material, this.manufacturing, this.variations, this.design)
                }
                else {
                    this.unit_cost = UnitCost(
                        this.material,
                        this.manufacturing,
                        this.variations,
                        this.getAFValue(this.advanced_feature));
                }

                this.message = `unit cost = ${this.unit_cost}`
                this.calculate = true;
            }
        },
        async editProduct() {

            if (this.$refs.form.validate()) {

                const prod = {
                    
                    id: this.product.id,
                    team: this.product.team,
                    trademark: this.product.trademark,
                    model: this.model,

                    available_from: this.available_from,
                    available_till: this.available_till,
                    material: this.material,
                    manufacturing: this.manufacturing,
                    design_type: this.design_type,
                    design: this.design,
                    variations: this.variations,
                    advanced_feature: this.advanced_feature,
                    sales_plan: this.sales_plan,
                    production_plan: this.production_plan,
                    retail_price: this.retail_price,
                    price: this.price,
                    investments: this.product.investments,
                    unit_cost: this.unit_cost,
                }
                /*console.log(prod) */
                try {
                    //add product
                    await this.$store.dispatch('editProduct', prod)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            } 
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.calculate = false;
            this.haveBeenChanged = false;
            
            this.trademark = this.product.trademark.name;
            this.model = this.product.model;
            this.team = this.product.team.name; 
            
            this.available_from = this.product.available_from;
            this.available_till = this.product.available_till;
            this.material = this.product.material;
            this.manufacturing = this.product.manufacturing;
            this.design_type = this.product.design_type;
            this.design = this.product.design;
            this.variations = this.product.variations;
            this.sales_plan = this.product.sales_plan;
            this.production_plan = this.product.production_plan;
            this.retail_price = this.product.retail_price;
            this.price = this.product.price;
            this.unit_cost = this.product.unit_cost;
        }
    },    
}
</script>